module.exports = __webpack_public_path__ + "img/icon_shop_04.1470e88f.png";